<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      'USER_SIGNOUT': 'USER_SIGNOUT'
    }),
    toUser() {
      this.$router.push({
        path: '/'
      })
    },
    handleCommand(command) {
      switch (command) {
        case 'exit':
          this.$message.success('退出登录')
          this.USER_SIGNOUT()
          this.$router.push('/login')
          break
        case 'password':
          this.$router.push({
            path: '/form/changePassword'
          })
          break
        default: console.log('你是咋跳到这儿来的。。')
      }
    },
  },
  computed: {
    ...mapGetters(['user', 'meta'])
  }
}
</script>
<style lang="less" scoped>
@import "./assets/styles/common.less";
body,html{
  background: #F4f4f4;
  .el-header{
    width: 100%;
    background: #fff;
    height: 84 / @h!important;
  }
}
@media screen and (max-width: 750px) {
  body,html {
    .el-header {
      height: 50 / @h!important;
      .header-main {
         width: 100%;
      }
    }
  }
}
</style>

